/**
 * Inline status message (success, error, info).
 */
const styles = {
  success: "border-emerald-500/40 bg-emerald-950/40 text-emerald-100",
  error: "border-rose-500/40 bg-rose-950/40 text-rose-100",
  info: "border-sky-500/40 bg-sky-950/40 text-sky-100",
};

export default function Alert({ severity = "info", children, className = "" }) {
  return (
    <div
      role="alert"
      className={`rounded-lg border px-3 py-2 text-sm ${styles[severity] || styles.info} ${className}`.trim()}
    >
      {children}
    </div>
  );
}
